import _ from "lodash";
import { storage } from "../../config/firebaseConfig";
import {
  adAudioCollection,
  adCardCollection,
  adCardSetupCollection,
  adCardTriggerCollection,
  adScheduleCollection,
  audioFilesTrashCollection,
  businessCollection,
  transactionCollection,
} from "../../config/collectionsConfig";
import sanitize from "sanitize-filename";
import { adSetupCreation, chunk } from "../../functions/buyairtime";

//import { adSetupCreation } from "d:/code for dagim v4";
// oldadschedules,
// adschedules,
// adcard,
// setupLimitPerDoc

export const BuyAirTime = (
  hash,
  newadSchedules,
  trashfileid,
  newadcard,
  sda
) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      dispatch(StartSubmitting());
      if (getState().profile.region.businessStatus) {
        const firestore = getFirestore();
        var profileRef = firestore
          .collection(businessCollection)
          .doc(getState().profile.profile.id);
        var adCardDocRef = firestore.collection(adCardCollection).doc();
        var adFilesRef = firestore
          .collection(audioFilesTrashCollection)
          .doc(trashfileid);
        var transactionRef = firestore.collection(transactionCollection).doc();
        //var adSetupCreation = null;

        const newAdAudioRef = firestore.collection(adAudioCollection).doc();
        const newAdTriggerRef = firestore
          .collection(adCardTriggerCollection)
          .doc(adCardDocRef.id);

        firestore
          .collection(adScheduleCollection)
          .where("systemAccountId", "==", getState().profile.region.id)
          .get()
          .then((adsccs) => {
            var tempnewadschs = {};
            firestore
              .runTransaction((t) => {
                return t.get(profileRef).then((balance) => {
                  var negiotio = balance.data();

                  if (negiotio.balance >= newadcard.adCardBalance) {
                    adsccs.forEach((adscc) => {
                      tempnewadschs = {
                        ...adscc.data().adSchedules,
                        ...tempnewadschs,
                      };
                    });

                    //console.log(tempnewadschs);
                    // adsccs.forEach((adscc) => {
                    //   tempnewadschs = {
                    //     ...adscc.data().adSchedules,
                    //     ...tempnewadschs,
                    //   };
                    // });

                    // getState().region.scheduleslist.forEach((ad) => {
                    //   tempoldadschs = {
                    //     ...ad,
                    //     ...tempoldadschs,
                    //   };
                    // });

                    console.log(tempnewadschs);
                    console.log(getState().region.scheduleslist);

                    if (
                      _.isEqual(tempnewadschs, getState().region.scheduleslist)
                    ) {
                      console.log("SAME");
                      t.update(adFilesRef, {
                        array: firestore.FieldValue.arrayRemove(
                          getState().airtime.uploaded
                        ),
                      });
                      console.log("AD TRASH REMOVED");
                      var adCardSetups = adSetupCreation(
                        newadcard,
                        getState().profile.region.setupLimitPerDoc
                      );
                      adCardSetups.forEach((adcs) => {
                        const newAdCardSetupDocRef = firestore
                          .collection(adCardSetupCollection)
                          .doc();
                        t.set(newAdCardSetupDocRef, {
                          adCardID: adCardDocRef.id,
                          availableSetups: [],
                          activeForDate: false,
                          adCardBalance: adcs.adCardBalance,
                          timeScore: 0,
                          cm: adcs.cm,
                          sp: adcs.sp,
                          completed: false,
                          systemAccountId: getState().profile.region.id,
                          ts: adcs.ts,
                          length: adcs.length,
                          frequency_per_route: adcs.frequency_per_route,
                        });
                        console.log("NEW ADCARD SETUP ADDED");
                      });

                      const unix = parseInt(
                        (new Date().getTime() / 1000).toFixed(0)
                      );

                      t.set(newAdAudioRef, {
                        audioUrl: getState().airtime.uploaded,
                        hash: hash,
                        uniqueName:
                          sanitize(newadcard.name.split(".").join("_")) +
                          "_" +
                          unix.toString(),
                        systemAccountId: getState().profile.region.id,
                      });
                      console.log("NEW AUDIO FILE ADDED");

                      t.set(newAdTriggerRef, {
                        systemAccountID: getState().profile.region.id,
                        reCmTr: 0,
                        reSpTr: 0,
                        acc: 0,
                        dac: 0,
                        spToRemove: "",
                        cmToRemove: "",
                        deleted: false,
                        lastTvID: "dummyID",
                        lastAdSetID: "dummyID",
                      });
                      console.log("NEW AD TRIGGER ADDED");

                      adsccs.forEach((adscc) => {
                        var adScheduleMainRef = firestore
                          .collection(adScheduleCollection)
                          .doc(adscc.id);

                        t.delete(adScheduleMainRef);
                      });

                      const schsarr = [];
                      const schschunkedarr = [];
                      var i = 0;
                      while (true) {
                        const sch = newadSchedules[i];
                        if (sch === undefined) {
                          break;
                        } else {
                          schsarr.push(sch);
                        }
                        i++;
                      }
                      var keyCounter = 0;
                      chunk(
                        schsarr,
                        getState().profile.region.adScheduleAggregateLimit
                      ).forEach((ar) => {
                        const oneobj = {};

                        ar.forEach((adsc) => {
                          oneobj[keyCounter] = {
                            aalst: adsc.aalst,
                            aastd: adsc.aastd,
                            cm: adsc.cm,
                            ts: adsc.ts,
                            sp: adsc.sp,
                            date: adsc.date,
                          };
                          keyCounter++;
                        });
                        schschunkedarr.push(oneobj);
                      });
                      console.log(schschunkedarr);

                      schschunkedarr.forEach((chunkedAdSch) => {
                        var adScheduleMainRef = firestore
                          .collection(adScheduleCollection)
                          .doc();

                        t.set(adScheduleMainRef, {
                          adSchedules: chunkedAdSch,
                          systemAccountId: getState().profile.region.id,
                        });
                      });

                      // var keyCounter = 0;
                      // var mapAsJson = {};
                      // newadSchedules.forEach((adsc) => {
                      //   mapAsJson[keyCounter] = {
                      //     aalst: adsc.aalst,
                      //     aastd: adsc.aastd,
                      //     cm: adsc.cm,
                      //     ts: adsc.ts,
                      //     sp: adsc.sp,
                      //     date: adsc.date,
                      //   };
                      //   keyCounter++;
                      // });

                      // var adScheduleMainRef = firestore
                      //   .collection(adScheduleCollection)
                      //   .doc();

                      // t.set(adScheduleMainRef, {
                      //   adSchedules: mapAsJson,
                      //   systemAccountId: getState().profile.region.id,
                      // });
                      var taspcdobj = {};
                      for (let ij = 0; ij < newadcard.tascpd.length; ij++) {
                        taspcdobj[ij] = {
                          date: newadcard.tascpd[ij].date,
                          value: newadcard.tascpd[ij].value,
                        };
                      }

                      console.log("AD SCHEDULES RESET");
                      var cadcard = {
                        name: newadcard.name,
                        length: newadcard.length,
                        frequency_per_route: newadcard.frequency_per_route,
                        cm: newadcard.cm,
                        sp: newadcard.sp,
                        ts: newadcard.ts,
                        completed: false,
                        created_date: new Date(
                          Date.parse(newadcard.created_date)
                        ),
                        end_date: new Date(Date.parse(newadcard.end_date)),
                        status: 0,
                        sda: sda,
                        start_date: new Date(Date.parse(newadcard.start_date)),
                        systemAccountID: getState().profile.region.id,
                        tascpd: taspcdobj,
                        businessId: getState().profile.profile.id,
                        amountPaid: newadcard.adCardBalance,
                        adCardBalance: newadcard.adCardBalance,
                        refund: 0,
                        readyToComplete: false,
                        adAudioID: newAdAudioRef.id,
                        totalNumberOfAdsServed: 0,
                        totalServedAmount: 0,
                        lastTvID: "dummyID",
                        lastAdSetID: "dummyID",
                      };
                      // const jsonstring = JSON.stringify(cadcard);
                      // const adcardobj = JSON.parse(jsonstring);
                      // adcardobj.created_date = new Date(
                      //   Date.parse(newadcard.created_date)
                      // );
                      // adcardobj.start_date = new Date(
                      //   Date.parse(newadcard.start_date)
                      // );
                      // adcardobj.end_date = new Date(
                      //   Date.parse(newadcard.end_date)
                      // );
                      //const nwadcardobj = adcardobj;
                      // for (let ti = 0; ti < adcardobj.tascpd.length; ti++) {
                      //   console.log(nwadcardobj.tascpd[ti].date)
                      //   console.log(nwadcardobj.tascpd[ti].date)
                      //   const element = adcardobj.tascpd[ti];
                      //   nwadcardobj.tascpd[ti].date = new Date(
                      //     Date.parse(element.date)
                      //   );
                      // }
                      t.set(adCardDocRef, cadcard); //pa);
                      console.log("NEW ADCARD ADDED");
                      const newBalance =
                        negiotio.balance - newadcard.adCardBalance;
                      t.update(profileRef, {
                        balance: newBalance,
                      });
                      console.log("BUSINESS BALANCE UPDATED");
                      t.set(transactionRef, {
                        amount: newadcard.adCardBalance,
                        author: getState().profile.profile.id,
                        bank: "",
                        timestamp: new Date(),
                        reciever: adCardDocRef.id,
                        sender: getState().profile.profile.id,
                        specificType: 3, //business payment
                        status: 2,
                        transferType: 1,
                        txnid: transactionRef.id,
                        type: 1,
                        updated_at: new Date(),
                        approved_by: "",
                        systemAccountId: getState().profile.profile.region,
                      });
                      console.log("BUSINESS PAYMENT MADE");
                    } else {
                      throw new Error("Differenet Ad Schedule");
                    }
                  } else {
                    console.log("Insufficent Funds");
                    throw new Error("Insufficent Funds");
                  }
                });
              })
              .then((result) => {
                // TRANSACTION_SUCCESS action dispatched
                dispatch({ type: "BUY_AIR_TIME" });
                console.log("Transaction success!");
              })
              .catch((err) => {
                // TRANSACTION_FAILURE action dispatched
                dispatch({ type: "BUY_AIR_TIME_ERROR", payload: err });
                console.log("Transaction failure:", err);
              });
          })
          .catch((err) => {
            dispatch({ type: "BUY_AIR_TIME_ERROR", payload: err });
          });

        // firestore
        //   .runTransaction((t) => {
        //     return t.get(adScheduleRef).then((doc) => {
        //       if (md5(doc.data().adSchedules) === md5(adSch.adSchedules)) {
        //         if (getState().profile !== null) {
        //           if (getState().profile.region !== null) {
        //             console.log("THE SAME");

        //             t.update(adFilesRef, {
        //               array: firestore.FieldValue.arrayRemove(
        //                 getState().airtime.uploaded
        //               ),
        //             });
        //             console.log("AD TRASH REMOVED");
        //             var adCardSetups = adSetupCreation(
        //               newadcard,
        //               getState().profile.region.setupLimitPerDoc
        //             );
        //             adCardSetups.forEach((adcs) => {
        //               const newAdCardSetupDocRef = firestore
        //                 .collection(adCardSetupCollection)
        //                 .doc();
        //               t.set(newAdCardSetupDocRef, {
        //                 adCardID: adCardDocRef.id,
        //                 availableSetups: [],
        //                 activeForDate: false,
        //                 adCardBalance: adcs.adCardBalance,
        //                 timeScore: 0,
        //                 cm: adcs.cm,
        //                 sp: adcs.sp,
        //                 completed: false,
        //                 systemAccountID: getState().profile.region.id,
        //                 ts: adcs.ts,
        //                 length: adcs.length,
        //                 frequency_per_route: adcs.frequency_per_route,
        //               });
        //               console.log("NEW ADCARD SETUP ADDED");
        //             });

        //             t.set(newAdAudioRef, {
        //               audioUrl: getState().airtime.uploaded,
        //               hash: hash,
        //               uniqueName: makeid(20),
        //               systemAccountId: getState().profile.region.id,
        //             });
        //             console.log("NEW AUDIO FILE ADDED");

        //             var keyCounter = 0;
        //             var mapAsJson = {};
        //             newadSchedules.forEach((adsc) => {
        //               mapAsJson[keyCounter] = {
        //                 aalst: adsc.aalst,
        //                 aastd: adsc.aastd,
        //                 cm: adsc.cm,
        //                 ts: adsc.ts,
        //                 sp: adsc.sp,
        //                 date: adsc.date,
        //               };
        //               keyCounter++;
        //             });

        //             // t.set(adScheduleMainRef, {
        //             //   adSchedules: mapAsJson,
        //             //   systemAccountId: getState().profile.region.id,
        //             // });
        //             console.log("AD SCHEDULES RESET");
        //             var cadcard = {
        //               name: newadcard.name,
        //               length: newadcard.length,
        //               frequency_per_route: newadcard.frequency_per_route,
        //               cm: newadcard.cm,
        //               sp: newadcard.sp,
        //               ts: newadcard.ts,
        //               completed: false,
        //               created_date: newadcard.created_date,
        //               end_date: newadcard.end_date,
        //               status: 0,
        //               sda: sda,
        //               start_date: newadcard.start_date,
        //               systemAccountId: getState().profile.region.id,
        //               tascpd: newadcard.tascpd,
        //               businessId: getState().profile.profile.id,
        //               amountPaid: newadcard.adCardBalance,
        //               adCardBalance: newadcard.adCardBalance,
        //               refund: 0,
        //               readyToComplete: false,
        //               adAudioId: newAdAudioRef.id,
        //               totalNumberOfAdsServed: 0,
        //               totalServedAmount: 0,
        //             };
        //             const jsonstring = JSON.stringify(cadcard);

        //             t.set(adCardDocRef, JSON.parse(jsonstring)); //pa);
        //             console.log("NEW ADCARD ADDED");
        //           }
        //         }
        //       } else {
        //         console.log("DIFFERENT");
        //       }
        //     });
        //   })
        //   .then((result) => {
        //     // TRANSACTION_SUCCESS action dispatched
        //     dispatch({ type: "BUY_AIR_TIME" });
        //     console.log("Transaction success!");
        //   })
        //   .catch((err) => {
        //     // TRANSACTION_FAILURE action dispatched
        //     console.log("Transaction failure:", err);
        //   });
      } else {
        dispatch({
          type: "BUY_AIR_TIME_ERROR",
          payload: "Airtime Purchase is Temporarily Blocked!",
        });
      }
    } catch (err) {
      dispatch({ type: "BUY_AIR_TIME_ERROR", payload: err });
    }
  };
};

export const UploadADAudio = (audio) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    const fullarray = audio.name.split(".");
    const unix = parseInt((new Date().getTime() / 1000).toFixed(0));
    const newname = fullarray[0] + "_" + unix.toString() + "_." + fullarray[1];
    try {
      dispatch(StartLoading());
      dispatch(ClearAudio());
      const firestore = getFirestore();
      const uploadTask = storage.ref("adAudio/" + newname).put(audio);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          dispatch({ type: "UPLOAD_AD_AUDIO_ERROR", payload: error });
        },
        () => {
          storage
            .ref("/adAudio")
            .child(newname)
            .getDownloadURL()
            .then((url) => {
              firestore
                .collection(audioFilesTrashCollection)
                .where("systemAccountId", "==", getState().profile.region.id)
                .get()
                .then((trashes) => {
                  if (trashes.size > 0) {
                    var cmid = "";
                    trashes.forEach((element) => {
                      cmid = element.id;
                    });
                    firestore
                      .collection(audioFilesTrashCollection)
                      .doc(cmid)
                      .update({
                        array: firestore.FieldValue.arrayUnion(url),
                      })
                      .then(() => {
                        dispatch({
                          type: "UPLOAD_AD_AUDIO",
                          payload: {
                            uploaded: url,
                            trashfilesid: cmid,
                          },
                        });
                      });
                  } else {
                    dispatch({
                      type: "UPLOAD_AD_AUDIO",
                      payload: {
                        uploaded: url,
                        trashfilesid: cmid,
                      },
                    });
                  }
                })
                .catch((e) => {
                  dispatch({ type: "UPLOAD_AD_AUDIO_ERROR", payload: e });
                });
            });
        }
      );
    } catch (e) {
      dispatch({ type: "UPLOAD_AD_AUDIO_ERROR", payload: e });
    }
  };
};

const ClearAudio = () => {
  return {
    type: "CLEAR_AD_AUDIO",
  };
};

const StartLoading = () => {
  return {
    type: "LOADING_BUY_AIR_TIME",
  };
};

const StartSubmitting = () => {
  return {
    type: "SUBMITTING_BUY_AIR_TIME",
  };
};
